module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_tjorn-5ebfd406ab98337f7a27835b54732048.png";